<template>
	<div class="warp">
		<div class="EnergyConsumption">
			<div class="title row-center">
				<div class="row-center">
					<el-date-picker
					:editable="false"
					:picker-options="pickerOptions"
					:clearable="false"
					class="dateSelect"
					v-model="date"
					:format="radio === 'week' ? 'yyyy 第 WW 周' : ''"
					:type="radio === 'day' ? 'date' : radio"
					:placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
					>
					</el-date-picker>
					
					<div class="radio">
						<el-radio v-model="radio" label="year">年</el-radio>
						<el-radio v-model="radio" label="month">月</el-radio>
						<el-radio v-model="radio" label="week">周</el-radio>
						<el-radio v-model="radio" label="day">日</el-radio>
					</div>
					<el-button plain class="btn per" @click="perD" v-if="radio === 'day'" >
						上一日
					</el-button>
					<el-button plain class="btn per" @click="perM" v-if="radio === 'month'" >
						上一月
					</el-button>
					<el-button plain class="btn per" @click="perW" v-if="radio === 'week'">
						上一周
					</el-button>
					<el-button plain class="btn per" @click="perY" v-if="radio === 'year'">
						上一年
					</el-button>
					<el-button
						class="btn next"
						plain
						@click="nextD"
						v-if="radio === 'day'"
						:disabled="nextDayDisabled"
						>下一日
					</el-button>
					<el-button
						class="btn next"
						plain
						@click="nextM"
						v-if="radio === 'month'"
						:disabled="nextDayDisabled">
						下一月
					</el-button>
					<el-button
						class="btn next"
						plain
						@click="nextW"
						v-if="radio === 'week'"
						:disabled="nextDayDisabled"
						>
						下一周
					</el-button>
					<el-button
						class="btn next"
						plain
						@click="nextY"
						v-if="radio === 'year'"
						:disabled="nextDayDisabled"
						>下一年
					</el-button>
				</div>
			</div>
			<div class="typeDetails">
				<div  :class="item.val == '0.00'?'type nothing': energyIdx == index?'type se':'type'" v-for="(item, index) in typeList" :key="item.id" @click="tabEnergyidx(index,item.val)">
					<img :src="item.img" alt="">
					<div class="con">
						<div>{{item.title + item.type}}</div>
						<div>{{item.val == '0.00'?'--':item.val}} <span v-show="item.val !== '0.00'">{{item.unit}}</span></div>
						<div v-show="item.lift !== 'same'" :class="item.lift == 'up'?'up down':'up '">{{item.per}}%</div>
					</div>
				</div>
			</div>
			<div class="mulberry">
				<div class="mulName">能源流向桑基图</div>
				<div id="nulBerryDiagram">
					<Loading LoadingId="mulberryLoading" :scale="0.7" v-if="lines.length == 0 && isRequest == true"/>
					<img src="../../assets/img/not_found_data.png"  v-if="isRequest == false && lines.length > 0 && lines[0].value == '0.00'" alt="">
					<div style="height:1000px" v-if="this.$store.getters.projectId==4||this.$store.getters.projectId==13">
						<Charts id="mulberry"  v-if="lines.length > 0 && lines[0].value !== '0.00'" :option="optionBerry"></Charts>
					</div>
					<div style="height:100%" v-else>
						<Charts id="mulberry"  v-if="lines.length > 0 && lines[0].value !== '0.00'" :option="optionBerry"></Charts>
					</div>
				</div>
			</div>
		</div>
		<div class="energyxou">
			<div class="title">能耗趋势</div>
			
			<div class="warp" >
				<!-- <Charts id="chartqushi" v-if="currentArr.length >0"  :option="option1"></Charts> -->
				<!-- <Charts id="chartqushi"  :option="option1"></Charts> -->
				<Charts id="chartqushi"  :option="optionItme"></Charts>
				<!-- <div class="nothing" v-else></div> -->
			</div>
		</div>
	</div>
    
</template>

<script>
import {
	perDay,
	perMonth,
	perYear,
	nextDay,
	nextMonth,
	nextYear,
	dateFormat,
	dateToString,
	dayStart,
	dayEnd,
	addDay,
	monthDays,
	getWeekDayArr,
	getWeekDays,
	getAppointedDate,
	getDiffDate,
	weekStart,
	weekEnd,
	} from "../../util/DateUtil";
import * as echarts from 'echarts';
import {EleResize} from '../../util/a.js'
import { getProjectTypeEnergy,getMulberryDistribute, getMulberryItemDistribute,getitemEnergyConsumption,
		 getProjectItemEnergy, getProjecTypeEnergyConsumption, getProjecConvertedStandardCoal, getConsumeMulberry } from '../../api/power'

import  Charts  from '../../components/common/Charts.vue'
import Loading from '../../components/common/Loading.vue'
export default {
	components: {
		Charts, Loading
	},
	data() {
		return {
			currentArr:[], // 当前 的图表数据
			pickerOptions: {
				firstDayOfWeek: 1,
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			colors : ['90,216,166', '61,163,245', '249,106,73', '56,190,215', '213,111,27'],
			color:'',
			units:['kWh', 'm³', 'GJ', 'GJ', 'tce'],
			titles:[],
			lines:[],
			date: new Date(),
			radio: "day",
			twoDays:[], // 两天的数据
			myChart:null,  // 分类图表dom
			myChartBerry:null,
			energyIdx:0,
			isRequest:true,
			xAxisData:{},
			timer:null,
			itemArr:{}, // 能耗堆叠图对象数组 
			typeList:[
				{
					id:2,
					title:'日',
					type:'用电',
					val:'0.00',
					img:require('../../assets/img/useelect.png'),
					unit:'kWh',
					per:'--',
					lift:'same',
					tag:'power'
				},
				{
					id:3,
					title:'日',
					type:'用水',
					val:'0.00',
					img:require('../../assets/img/usewater.png'),
					unit:'m³',
					per:'--',
					lift:'same',
					tag:'water'
				},
				{
					id:4,
					title:'日',
					type:'用热',
					val:'0.00',
					img:require('../../assets/img/usehot.png'),
					unit:'GJ',
					per:'--',
					lift:'same',
					tag:'heat'
				},
				{
					id:5,
					title:'日',
					type:'用冷',
					val:'0.00',
					img:require('../../assets/img/usecold.png'),
					unit:'GJ',
					per:'--',
					lift:'same',
					tag:'cooling'
				},
				{
					id:1,
					title:'日',
					type:'总能耗',
					val:'0.00',
					img:require('../../assets/img/usecan.png'),
					unit:'tce',
					per:'--',
					lift:'same',
					tag:'sum'
				},
			],
			
		}
	},
	computed: {
		nextDayDisabled() {
			let timestamp = dateFormat("YY-mm-dd", new Date());
			let endtime = dateFormat("YY-mm-dd", this.date);
			if (this.radio === "year") {
				timestamp = dateFormat("YY", new Date());
				endtime = dateFormat("YY", this.date);
			} else if (this.radio === "month") {
				timestamp = dateFormat("YY-mm", new Date());
				endtime = dateFormat("YY-mm", this.date);
			} else if (this.radio === "week") {
				timestamp = dateFormat("YY-mm-dd", new Date());
				endtime = dateFormat("YY-mm-dd", addDay(this.date, 5));
			}
			if (endtime >= timestamp) {
				return true;
			} else {
				return false;
			}
		},
		optionBerry(){
			let _this = this
			return {
				// title: {
				// 	text: 'Sankey Diagram'
				// },
				tooltip: {
					trigger: 'item',
					triggerOn: 'mousemove',
					formatter: function (params) {
						// console.log(params);
						if(_this.$store.getters.selProjectInfo.projectType == 1){
							if(params.data.target){
								return `${params.data.target} ${Number(params.value).toFixed(2)} ${_this.units[_this.energyIdx]}`
							}else{
								return `${params.name} ${Number(params.value).toFixed(2)} ${_this.units[_this.energyIdx]}`
							}
						}else{
							if(params.data.target){
								if(params.data.target.indexOf('-') == -1){
									return `${params.data.target} ${Number(params.value).toFixed(2)} ${_this.units[_this.energyIdx]}`
								}else{
									return `${params.data.target.split('-')[1]} ${Number(params.value).toFixed(2)} ${_this.units[_this.energyIdx]}`
								}
							}else{
								if(params.name.indexOf('-') == -1){
									return `${params.name} ${Number(params.value).toFixed(2)} ${_this.units[_this.energyIdx]}`
								}else{
									return `${params.name.split('-')[1]} ${Number(params.value).toFixed(2)} ${_this.units[_this.energyIdx]}`
								}
							}
						}

						
						
					}
				},
				dataZoom: [
				{
					id: 'dataZoomY',
					yAxisIndex: [0],
					show: true, //是否显示滑动条，不影响使用
					type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
					startValue: 0, // 从头开始。
					endValue: 4, // 一次性展示5个
					width: 6,
					borderColor: 'transparent',
					fillerColor: 'rgba(205,205,205,1)',
					zoomLock: true,
					showDataShadow: false, //是否显示数据阴影 默认auto
					backgroundColor: '#fff',
					showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
					realtime: true, //是否实时更新
					filterMode: 'filter',
					handleIcon: 'circle',
					handleStyle: {
					color: 'rgba(205,205,205,1)',
					borderColor: 'rgba(205,205,205,1)',
					},
					handleSize: '80%',
					moveHandleSize: 0,
					maxValueSpan: 4,
					minValueSpan: 4,
					brushSelect: false, //刷选功能，设为false可以防止拖动条长度改变 ************（这是一个坑）
				}, {
					type: 'inside',
					yAxisIndex: 0,
					zoomOnMouseWheel: false,  //滚轮是否触发缩放
					moveOnMouseMove: true,  //鼠标滚轮触发滚动
					moveOnMouseWheel: true
				}],
				series: [
					{
					left: '0%',
					top: '3%',
					right: '15%',
					bottom: '2%',
					type: 'sankey',
					// data: [
					// 	{"name": "Total"},
					// 	{"name": "Environment"},
					// 	{"name": "Land use"},
					// 	{"name": "Cocoa butter (Organic)"},
					// 	{"name": "Cocoa mass (Organic)"},
					// 	{"name": "Hazelnuts (Organic)"},
					// 	{"name": "Cane sugar (Organic)"},
					// 	{"name": "Vegetables (Organic)"},
					// 	{"name": "Climate change"},
					// 	{"name": "Harmful substances"},
					// 	{"name": "Water use"},
					// 	{"name": "Resource depletion"},
					// 	{"name": "Refrigeration"},
					// 	{"name": "Packaging"},
					// 	{"name": "Human rights"},
					// 	{"name": "Child labour"},
					// 	{"name": "Coconut oil (Organic)"},
					// 	{"name": "Forced labour"},
					// 	{"name": "Health safety"},
					// 	{"name": "Access to water"},
					// 	{"name": "Freedom of association"},
					// 	{"name": "Access to land"},
					// 	{"name": "Sufficient wage"},
					// 	{"name": "Equal rights migrants"},
					// 	{"name": "Discrimination"},
					// 	{"name": "Working hours"}
					// ],
					data:this.titles,
					links:this.lines,
					// links: [
					// 	{"source": "Total", "target": "Environment", "value": 0.342284047256003},
					// 	{"source": "Environment", "target": "Land use", "value": 0.32322870366987},
					// 	{"source": "Land use", "target": "Cocoa butter (Organic)", "value": 0.177682517071359},
					// 	{"source": "Land use", "target": "Cocoa mass (Organic)", "value": 0.137241325342711},
					// 	{"source": "Land use", "target": "Hazelnuts (Organic)", "value": 0.00433076373512774},
					// 	{"source": "Land use", "target": "Cane sugar (Organic)", "value": 0.00296956039863467},
					// 	{"source": "Land use", "target": "Vegetables (Organic)", "value": 0.00100453712203756},
					// 	{"source": "Environment", "target": "Climate change", "value": 0.0112886157414413},
					// 	{"source": "Climate change", "target": "Cocoa butter (Organic)", "value": 0.00676852971933996},
					// 	{"source": "Climate change", "target": "Cocoa mass (Organic)", "value": 0.00394686874786743},
					// 	{"source": "Climate change", "target": "Cane sugar (Organic)", "value": 0.000315972058711838},
					// 	{"source": "Climate change", "target": "Hazelnuts (Organic)", "value": 0.000218969462265292},
					// 	{"source": "Climate change", "target": "Vegetables (Organic)", "value": 3.82757532567656e-05},
					// 	{"source": "Environment", "target": "Harmful substances", "value": 0.00604275542495656},
					// 	{"source": "Harmful substances", "target": "Cocoa mass (Organic)", "value": 0.0055125989240741},
					// 	{"source": "Harmful substances", "target": "Cocoa butter (Organic)", "value": 0.000330017607892127},
					// 	{"source": "Harmful substances", "target": "Cane sugar (Organic)", "value": 0.000200138892990337},
					// 	{"source": "Harmful substances", "target": "Hazelnuts (Organic)", "value": 0},
					// 	{"source": "Harmful substances", "target": "Vegetables (Organic)", "value": 0},
					// 	{"source": "Environment", "target": "Water use", "value": 0.00148345269044703},
					// 	{"source": "Water use", "target": "Cocoa butter (Organic)", "value": 0.00135309891304186},
					// 	{"source": "Water use", "target": "Cocoa mass (Organic)", "value": 0.000105714137908639},
					// 	{"source": "Water use", "target": "Hazelnuts (Organic)", "value": 1.33452642581887e-05},
					// 	{"source": "Water use", "target": "Cane sugar (Organic)", "value": 8.78074837009238e-06},
					// 	{"source": "Water use", "target": "Vegetables (Organic)", "value": 2.5136268682477e-06},
					// 	{"source": "Environment", "target": "Resource depletion", "value": 0.000240519729288764},
					// 	{"source": "Resource depletion", "target": "Cane sugar (Organic)", "value": 0.000226237279345084},
					// 	{"source": "Resource depletion", "target": "Vegetables (Organic)", "value": 1.42824499436793e-05},
					// 	{"source": "Resource depletion", "target": "Hazelnuts (Organic)", "value": 0},
					// 	{"source": "Resource depletion", "target": "Cocoa mass (Organic)", "value": 0},
					// 	{"source": "Resource depletion", "target": "Cocoa butter (Organic)", "value": 0},
					// 	{"source": "Environment", "target": "Refrigeration", "value": 0},
					// 	{"source": "Environment", "target": "Packaging", "value": 0},
					// 	{"source": "Total", "target": "Human rights", "value": 0.307574096993239},
					// 	{"source": "Human rights", "target": "Child labour", "value": 0.0410641202645833},
					// 	{"source": "Child labour", "target": "Hazelnuts (Organic)", "value": 0.0105339381639722},
					// 	{"source": "Child labour", "target": "Cocoa mass (Organic)", "value": 0.0105},
					// 	{"source": "Child labour", "target": "Cocoa butter (Organic)", "value": 0.0087294420777},
					// 	{"source": "Child labour", "target": "Coconut oil (Organic)", "value": 0.00474399974233333},
					// 	{"source": "Child labour", "target": "Cane sugar (Organic)", "value": 0.00388226450884445},
					// 	{"source": "Child labour", "target": "Vegetables (Organic)", "value": 0.00267447577173333},
					// 	{"source": "Human rights", "target": "Forced labour", "value": 0.0365458590642445},
					// 	{"source": "Forced labour", "target": "Hazelnuts (Organic)", "value": 0.0114913076376389},
					// 	{"source": "Forced labour", "target": "Cocoa butter (Organic)", "value": 0.0081134807347},
					// 	{"source": "Forced labour", "target": "Cocoa mass (Organic)", "value": 0.00765230236575},
					// 	{"source": "Forced labour", "target": "Cane sugar (Organic)", "value": 0.004},
					// 	{"source": "Forced labour", "target": "Vegetables (Organic)", "value": 0.00296668823626667},
					// 	{"source": "Forced labour", "target": "Coconut oil (Organic)", "value": 0.00232208008988889},
					// 	{"source": "Human rights", "target": "Health safety", "value": 0.0345435327843611},
					// 	{"source": "Health safety", "target": "Hazelnuts (Organic)", "value": 0.0121419536385},
					// 	{"source": "Health safety", "target": "Cocoa mass (Organic)", "value": 0.00766772850678333},
					// 	{"source": "Health safety", "target": "Cocoa butter (Organic)", "value": 0.0056245892061},
					// 	{"source": "Health safety", "target": "Coconut oil (Organic)", "value": 0.00361616847688889},
					// 	{"source": "Health safety", "target": "Cane sugar (Organic)", "value": 0.00277374682533333},
					// 	{"source": "Health safety", "target": "Vegetables (Organic)", "value": 0.00271934613075556},
					// 	{"source": "Human rights", "target": "Access to water", "value": 0.0340206659360667},
					// 	{"source": "Access to water", "target": "Cocoa mass (Organic)", "value": 0.0105},
					// 	{"source": "Access to water", "target": "Cocoa butter (Organic)", "value": 0.0089274160792},
					// 	{"source": "Access to water", "target": "Hazelnuts (Organic)", "value": 0.0054148022845},
					// 	{"source": "Access to water", "target": "Cane sugar (Organic)", "value": 0.00333938149786667},
					// 	{"source": "Access to water", "target": "Vegetables (Organic)", "value": 0.00314663377488889},
					// 	{"source": "Access to water", "target": "Coconut oil (Organic)", "value": 0.00269243229961111},
					// 	{"source": "Human rights", "target": "Freedom of association", "value": 0.0320571523941667},
					// 	{"source": "Freedom of association", "target": "Hazelnuts (Organic)", "value": 0.0132312483463611},
					// 	{"source": "Freedom of association", "target": "Cocoa butter (Organic)", "value": 0.0077695200707},
					// 	{"source": "Freedom of association", "target": "Cocoa mass (Organic)", "value": 0.00510606573995},
					// 	{"source": "Freedom of association", "target": "Vegetables (Organic)", "value": 0.00354321156324444},
					// 	{"source": "Freedom of association", "target": "Cane sugar (Organic)", "value": 0.00240710667391111},
					// 	{"source": "Freedom of association", "target": "Coconut oil (Organic)", "value": 0},
					// 	{"source": "Human rights", "target": "Access to land", "value": 0.0315022209894056},
					// 	{"source": "Access to land", "target": "Hazelnuts (Organic)", "value": 0.00964970063322223},
					// 	{"source": "Access to land", "target": "Cocoa mass (Organic)", "value": 0.00938530207965},
					// 	{"source": "Access to land", "target": "Cocoa butter (Organic)", "value": 0.0060110791848},
					// 	{"source": "Access to land", "target": "Cane sugar (Organic)", "value": 0.00380818314608889},
					// 	{"source": "Access to land", "target": "Vegetables (Organic)", "value": 0.00264795594564445},
					// 	{"source": "Access to land", "target": "Coconut oil (Organic)", "value": 0},
					// 	{"source": "Human rights", "target": "Sufficient wage", "value": 0.0287776757227333},
					// 	{"source": "Sufficient wage", "target": "Cocoa mass (Organic)", "value": 0.00883512456493333},
					// 	{"source": "Sufficient wage", "target": "Cocoa butter (Organic)", "value": 0.0078343367268},
					// 	{"source": "Sufficient wage", "target": "Coconut oil (Organic)", "value": 0.00347879026511111},
					// 	{"source": "Sufficient wage", "target": "Hazelnuts (Organic)", "value": 0.00316254211388889},
					// 	{"source": "Sufficient wage", "target": "Vegetables (Organic)", "value": 0.00281013722808889},
					// 	{"source": "Sufficient wage", "target": "Cane sugar (Organic)", "value": 0.00265674482391111},
					// 	{"source": "Human rights", "target": "Equal rights migrants", "value" : 0.0271146645119444},
					// 	{"source": "Equal rights migrants", "target": "Cocoa butter (Organic)", "value": 0.0071042315061},
					// 	{"source": "Equal rights migrants", "target": "Cocoa mass (Organic)", "value": 0.00636673210005},
					// 	{"source": "Equal rights migrants", "target": "Hazelnuts (Organic)", "value": 0.00601459775836111},
					// 	{"source": "Equal rights migrants", "target": "Coconut oil (Organic)", "value": 0.00429185583138889},
					// 	{"source": "Equal rights migrants", "target": "Cane sugar (Organic)", "value": 0.00182647471915556},
					// 	{"source": "Equal rights migrants", "target": "Vegetables (Organic)", "value": 0.00151077259688889},
					// 	{"source": "Human rights", "target": "Discrimination", "value": 0.0211217763359833},
					// 	{"source": "Discrimination", "target": "Cocoa mass (Organic)", "value": 0.00609671700306667},
					// 	{"source": "Discrimination", "target": "Cocoa butter (Organic)", "value": 0.0047738806325},
					// 	{"source": "Discrimination", "target": "Coconut oil (Organic)", "value": 0.00368119084494444},
					// 	{"source": "Discrimination", "target": "Vegetables (Organic)", "value": 0.00286009813604444},
					// 	{"source": "Discrimination", "target": "Cane sugar (Organic)", "value": 0.00283706180951111},
					// 	{"source": "Discrimination", "target": "Hazelnuts (Organic)", "value": 0.000872827909916666},
					// 	{"source": "Human rights", "target": "Working hours", "value": 0.02082642898975},
					// 	{"source": "Working hours", "target": "Hazelnuts (Organic)", "value": 0.0107216773848333},
					// 	{"source": "Working hours", "target": "Coconut oil (Organic)", "value": 0.00359009052944444},
					// 	{"source": "Working hours", "target": "Vegetables (Organic)", "value": 0.00212300379075556},
					// 	{"source": "Working hours", "target": "Cocoa butter (Organic)", "value": 0.0018518584356},
					// 	{"source": "Working hours", "target": "Cocoa mass (Organic)", "value": 0.00158227069058333},
					// 	{"source": "Working hours", "target": "Cane sugar (Organic)", "value": 0.000957528158533333}
					// ],
					emphasis: {
						focus: 'none',   // series, self, adjacency
					},
					levels: [
						{
						depth: 0,
						itemStyle: {
							color: '#0D94FF'
						},
						lineStyle: {
							color: 'gradient', // source
							opacity: 0.6
						},
						label:{
							show:true,
							formatter: function (params) {
								// console.log(params.name.indexOf('-'));
								// console.log(params);
								
								if(_this.$store.getters.selProjectInfo.projectType == 1){
									return `${params.name}`
								}else{
									if(params.name.indexOf('-') != -1){
										return `${params.name.split('-')[1]}`
									}else{
										return `${params.name}`
									}
								}
							}
						}
						},
						{
						depth: 1,
						itemStyle: {
							color: '#F6BD16'
						},
						lineStyle: {
							color: 'gradient',
							opacity: 0.6
						},
						label:{
							show:true,
							formatter: function (params) {
								// console.log(params.name.indexOf('-'));
								if(_this.$store.getters.selProjectInfo.projectType == 1){
									return `${params.name}`
								}else{
									if(params.name.indexOf('-') != -1){
										return `${params.name.split('-')[1]}`
									}else{
										return `${params.name}`
									}
								}
								
							}
						}
						},
						{
						depth: 2,
						itemStyle: {
							color: '#E8684A'
						},
						lineStyle: {
							color: 'gradient',
							opacity: 0.6
						},
						label:{
							fontSize:8,
							fontWeight:'bold',
							show:true,
							formatter: function (params) {
								// console.log(params.name.indexOf('-'));
								if(_this.$store.getters.selProjectInfo.projectType == 1){
									return `${params.name}`
								}else{
									if(params.name.indexOf('-') != -1){
										return `${params.name.split('-')[1]}`
									}else{
										return `${params.name}`
									}
								} 
								
							}
						}
						},
						{
						depth: 3,
						itemStyle: {
							color: '#6DC8EC'
						},
						lineStyle: {
							color: 'gradient',
							opacity: 0.6
						},
						label:{
							show:true,
							fontSize:50,
							formatter: function (params) {
								// console.log(params.name.indexOf('-'));
								if(params.name.indexOf('-') != -1){
									return `${params.name.split('-')[1]}`
								}else{
									return `${params.name}`
								}
								
							}
						}
						}
					],
					lineStyle: {
						curveness: 0.5
					}
					}
				]
			}
		},
		option1(){
			let _this = this
			let arr = ['用电', '用水', '用冷', '用热', '折煤标']
			let option =  {
				title:{
					text:this.units[this.energyIdx],
					left: 13,// 距离左边位置
					top: 10,// 距离上面位置
					// textVerticalAlign:'right',
					textStyle:{
						fontWeight:'bold',
						fontSize:12,
						fontStyle:'italic'
					}
				},
				tooltip:{
					show:true,
					trigger:"axis",
					// axisPointer:{
					// 	type:'none'
					// },
					formatter: function (params) {
						let str = `${params[0].name}<br/>`;
						params.forEach((item, idx) => {
							str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value?item.value:'--'}</b><b style='font-size:14px;'> ${_this.units[_this.energyIdx]}</b>`;
							str += idx === params.length -1? '': '<br/>'
						})
						return str
					},
				},
				
				xAxis: {
					type: 'category',
					boundaryGap: true,
					data: this.xAxisData[this.radio],
					
					axisTick:{
						show:false
					},
					axisLine:{
						lineStyle:{
							color:'rgba(0,0,0,0.3)'
						},
						show:false
					},
					axisLabel:{
						show:true,
						color:'rgba(0,0,0,0.7)',
						fontWeight:'bold',
					},
					splitLine: {
                        lineStyle:{
                            type:'dashed',
                            color:'rgba(255, 255, 255, 0.3)'
                        }
                    }
				},
				grid: {
                    top: '25%',
                    right:'2%',
                    left:'5%',
					bottom:'15%'
                },
				yAxis: {
					min:0,
					max:this.currentArr.length > 0?null:100,
					type: 'value',
					axisLabel:{
						show :true,
						color:'rgba(0,0,0,0.7)',
						fontWeight:'bold',
					},
					axisTick:{
						show:false
					},
					
					splitLine: {
                        lineStyle:{
                            type:'dashed',
                            color:'rgba(0,0,0,0.1)'
                        }
                    }
				},
				series: [
					{
						name:arr[this.energyIdx],
						data: this.currentArr,
						type: 'line',
						smooth:0.3,
						areaStyle:true,
						symbol:'emptyCircle',
						symbolSize:5,
						itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: `rgba(${this.color}, 1)` //折线的颜色
                                }  ,
                                color: `rgba(${this.color}, 1)`,  //拐点颜色
								
                                
                            },
                            emphasis:{
                                color:`rgba(${this.color}, 1)`,
                                borderWidth:15,
                                borderColor:`rgba(${this.color}, 0.3)`,
                                // shadowColor:'#00FFFF',
                                // shadowBlur:10
								label:{
									show :false,
									// position:['50%', '-50%'],
									color:`rgba(${this.color}, 1)`,
									fontSize:20,
									fontWeight:"bold",
									offset:[35, 10]
								}
                            },
                            
                        },
						markPoint: {
                            symbol:'pin',
                            symbolSize:20,
                            data: [
                                { type: 'max', name: 'Max',},
                                // { type: 'min', name: 'Min',}
                            ],
                            label:{
                                position:'top',
								// backgroundColor:'#F6BD16',
								// padding:4,
								// borderRadius:8,
								// color:'#fff',
								// formatter: function (params) {
								// 	let str = `${params.name} `
								// 	return str 
								// },
								fontSize:14,
								formatter:function(params){
									// console.log(params);
									return `${params.value} kWh`
								}
                            }
                        },
                        areaStyle:{
                            normal: {
                                color:new echarts.graphic.LinearGradient(0,0,0,1,[
                                    {
                                        offset:0,
                                        color:`rgba(${this.color}, 1)`
                                    },
                                    {
                                        offset:1,
                                        color:`rgba(${this.color}, 0)`
                                    },
                                ])
                            }
                        }
					}
				]
			}
			return option
		},
		currentDate(){
			return dayStart(this.date)
		},
		optionItme () {
			
			return {
			color: ['#6dc8ec',  '#f6bd16', '#e8684a', '#9270ca'],
			tooltip: {
				trigger: "axis",
				textStyle: {
				color: "#333333" //设置文字颜色
				},
				formatter: function (params) {
				let str = `${params[0].name}<br/>`;
				params.forEach((item, idx) => {
					str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.data == null ?'--':item.data}</b><b style='font-size:14px;'> kWh</b>`;
					str += idx === params.length -1? '': '<br/>'
				})
				return str
				}
			},
			legend: {
				// orient: "vertical", //垂直显示
				// y: "10%", //延Y轴居中
				x: "right", //居右显示
				icon: "rect",
				// align: "left",
				itemWidth: 10,
				itemHeight: 10,
				textStyle: {
				fontSize: 15,
				fontWeight: 800,
				},
			},
			grid: {
				top:"12%",
				left: "0%",
				right: "2%",
				bottom: "3%",
				containLabel: true,
			},
			title: {
				text: 'kWh',
				textAlign:"left",
				left: -5,// 距离左边位置
				top: -5,// 距离上面位置
				textStyle:{
				align:"left",
				fontWeight:'bold',
				fontSize:12,
				color: "#333",
				fontStyle:'italic'
				}
			},
			xAxis: {
				type: "category",
				data:this.xAxisData[this.radio],
				axisLabel:{
					fontSize:12,
					color: "#333",
					fontWeight:'bold'
				},
				axisTick: {
				show: false
				},
			},
			yAxis: {
				type: "value",
				// offset:10,
				min:0,
				max: Object.keys(this.itemArr).length > 0 ?null:100,
				nameTextStyle: {
					align: "right",
					fontWeight:'bold',
					fontStyle:"italic",
					color: "#333",
				},
				splitLine:{
					show:true,
					lineStyle:{
						type:'dashed',
					}
				},
				axisLabel:{
					fontSize:12,
					color: "#333",
					fontWeight:'bold'
				}
			},
			series: [
				{
					name: "空调",
					type: "bar",
					stack: 'Ad',
					barWidth: 15,
					emphasis: {
					focus: 'series'
					},
					data: this.itemArr['AIR_CONDITIONER']
				},
				{
					name: "照明",
					type: "bar",
					stack: 'Ad',
					barWidth: 15,
					emphasis: {
					focus: 'series'
					},
					data: this.itemArr['LIGHTING']
				},
				{
					name: "动力",
					type: "bar",
					stack: 'Ad',
					barWidth: 15,
					emphasis: {
					focus: 'series'
					},
					data: this.itemArr['POWER']
				},
				{
					name: "特殊",
					type: "bar",
					stack: 'Ad',
					barWidth: 15,
					emphasis: {
					focus: 'series'
					},
					data: this.itemArr['SPECIAL']
				},
			],
			}
		}
	},
	watch: {
		currentDate(val){
			// console.log(val);
			this.getMonthWeekDate()
			console.log(this.energyIdx);
			this.tabEnergyidx(this.energyIdx)
		},
		radio(val){
			// console.log(val);
			this.tabEnergyidx(this.energyIdx)
		},
		  
	},
	mounted() {
		let _this = this
		this.getTime()
		
		this.tabEnergyidx(0)

		this.timer = setInterval(()=>{
			_this.getEnergyLink(_this.energyIdx)
		}, 3600 * 1000)
		
		
	},
	destroyed(){
		if(this.timer){
			clearInterval(this.timer)
			this.timer = null
			// console.log(this.timer);
		}
	},
	methods: {
		getTime(){
			let dayTime = []
			for(let i = 1;i<=24;i++){
				dayTime.push(i + '点')
			}
			this.xAxisData['day'] = dayTime

			let yearArr = []
			for(let i = 1;i<=12;i++){
				yearArr.push(i + '月')
			}
			this.xAxisData['year'] = yearArr
			this.getMonthWeekDate()
		},
		getMonthWeekDate(){
			let monthDay = monthDays(this.date)
			
			let monthArr = []
			for(let i = 1;i<=monthDay;i++){
				monthArr.push(i + '日')
			}
			this.xAxisData['month'] = monthArr

			let week = getWeekDayArr(this.date)
			
			this.xAxisData['week'] = week
		},
		perW() {
			let week = getAppointedDate(this.date, 1, 1);
			this.date = new Date(week.startDate);
		},
		nextW() {
			let week = getAppointedDate(this.date, 1, -1);
			this.date = new Date(week.startDate);
		},
		perD() {
			// console.log(this.date);
			this.date = perDay(this.date);
		},
		nextD() {
			this.date = nextDay(this.date);
		},
		perM() {
			this.date = perMonth(this.date);
		},
		nextM() {
			this.date = nextMonth(this.date);
		},
		perY() {
			this.date = perYear(this.date);
		},
		nextY() {
			this.date = nextYear(this.date);
		},
		// 获取能对趋势数据对比显示增长或者下降
		async typeEnergy(radio){
            let today = this.currentDate
			let yestorday = ''
			let radioIdx = 0
			switch(radio){
				case 'DAY':
					yestorday = dayStart(perDay(this.date)) 
					radioIdx = 0
					break;
				case 'WEEK':
					let week = getAppointedDate(this.date, 1, 1);
					yestorday = dayStart(new Date(week.startDate)) 
					radioIdx = 1
					break;
				case 'MONTH':
					yestorday = dayStart(perMonth(new Date())) 
					radioIdx = 2
					break;
				case 'YEAR':
					yestorday = dayStart(perYear(new Date())) 
					radioIdx = 3
					break;
			}
			
            try{
                let res = await Promise.all([
                    getProjectTypeEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        // range:'DAY'
                        range:radio
                    }),
                    getProjectTypeEnergy({
                        date:yestorday,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        // range:'DAY'
                        range:radio
                    }),
                ])
                // console.log(res);
				
				let arr = []
                res.forEach(item =>{
                    let result = item.data.data.result
                    let sum = result.coolingSC + result.heatSC + result.powerSC + result.waterSC

                    let obj = {
						power:result.power.toFixed(2),
						water:result.water.toFixed(2),
						heat:result.heat.toFixed(2),
						cooling:result.cooling.toFixed(2),
						sum:sum.toFixed(2)
					} 
					arr.push(obj)
                })
				// console.log(arr);
				let types = ['日', '周', '月', '年']
				this.typeList.forEach((item, index) =>{
					item.title = types[radioIdx]
					item.val = arr[0][item.tag]
					item.lift = arr[0][item.tag] - arr[1][item.tag] == 0?'same':arr[0][item.tag] - arr[1][item.tag] < 0?'down':'up'
					if(arr[0][item.tag] - arr[1][item.tag] == 0 && arr[1][item.tag] == 0){
						item.per = 0
					}else if(arr[1][item.tag] == 0){
						item.per = 100
					}else{
						item.per = ((Math.abs(arr[0][item.tag] - arr[1][item.tag]) / arr[1][item.tag]) * 100).toFixed(0)
					}
				})
            }catch(err){
                console.log(err);
            }
        },
		// 获取图表能耗趋势图表数据
		async getDiagramProjectTypeEnergy(type){
			let res = await getProjecTypeEnergyConsumption({
				projectId:this.$store.getters.projectId,
				date:this.currentDate,
				powerType:type.toUpperCase(),
				range:this.radio.toUpperCase()
			})
			// console.log(res);
			if(res.data.code == 200){
				let result = res.data.data.result
				this.currentArr = result[type].map(item =>{
					return item = item == null?null: Number(item).toFixed(2)
				})
				
			}else {
				// console.log(res.data.errMsg);
			}
		},
		// 获取折标煤图表
		async getProjecStandardCoal(){
			let res = await getProjecConvertedStandardCoal({
				projectId:this.$store.getters.projectId,
				date:this.currentDate,
				powerType:'',
				range:this.radio.toUpperCase()
			})
			console.log(res);
			if(res.data.code == 200){
				this.currentArr = res.data.data.result.total.map(item =>{
					return item = item == null?null: Number(item).toFixed(2)
				})
				
			}else{
				console.log('err:'+res.data.errMsg);
			}
		},
		async getMulberry(type){
			this.isRequest = true
			this.titles = []
			this.lines = []
			let res = await getConsumeMulberry({
				date:this.currentDate,
				projectId:this.$store.getters.projectId,
				range:this.radio.toUpperCase()
			})
			console.log(res);
			if(res.data.code == 200){
				
				let result = res.data.data

				this.recursive(result[Object.keys(result)[0]][0], type, '')

				console.log(this.titles);
				console.log(this.lines);
				this.isRequest = false
				
			}else{
				this.isRequest = false
				console.log('err:' + res.data.errMsg);
			}
		},
		recursive(level,type, parentName){
			let _this = this
			_this.titles.push({"name":parentName  + level.building.name})

			if(level.children && level.children.length > 0){
				level.children.forEach(item =>{
					if(type == 'total'){
						let total = item.value['coolingSC'] + item.value['heatSC'] + item.value['powerSC'] + item.value['waterSC']
						if(total !== 0){
							_this.lines.push({"source": parentName + level.building.name, "target":level.building.name +'-'+ item.building.name, "value":Number(total).toFixed(2) })
							// _this.lines.push({"source": level.building.name, "target": item.building.name, "value": 100})
						}
						
					}else{
						if(item.value[type] !== 0){
							_this.lines.push({"source": parentName + level.building.name, "target":level.building.name +'-'+  item.building.name, "value":Number(item.value[type]).toFixed(2) })
							// _this.lines.push({"source": level.building.name, "target": item.building.name, "value": 200})
						}
						
					}
					_this.recursive(item, type, level.building.name + '-')
				})
			}

		},
		async getMulberryItem(type){
			let _this = this
			this.isRequest = true
			this.titles = []
			this.lines = []
			let res = await getMulberryItemDistribute({
				date:this.currentDate,
				projectId:this.$store.getters.projectId,
				range:this.radio.toUpperCase()
			})
			if(res.data.code == 200){
				
				let result = res.data.data
				console.log(result);																											
				
				_this.titles.push({"name":result.name})
				result.childrenList.forEach(item =>{
					
					// if(item.data.electricity !== 0){
						_this.titles.push({"name":item.name})
						_this.lines.push({"source": result.name, "target":item.name, "value":Number(item.data.electricity).toFixed(2) })
					// }
					
					item.childrenList.forEach((loop,ldx)=>{
						if(loop.data.electricity !== 0){
							_this.titles.push({"name":loop.name})
						_this.lines.push({"source": item.name, "target":loop.name, "value":Number(loop.data.electricity).toFixed(2) })
						}
						
					
					})
				})

				// _this.titles.push({"name":result.project.projectName})
				// result.areas.forEach(item =>{
					
				// 	// if(item.data.electricity !== 0){
				// 		_this.titles.push({"name":item.area.areaName})
				// 		_this.lines.push({"source": result.project.projectName, "target":item.area.areaName, "value":Number(item.data.electricity).toFixed(2) })
				// 	// }
					
				// 	item.loops.forEach((loop,ldx)=>{
				// 		if(loop.data.electricity !== 0){
				// 			_this.titles.push({"name":loop.deviceLoop.loopName})
				// 		_this.lines.push({"source": item.area.areaName, "target":loop.deviceLoop.loopName, "value":Number(loop.data.electricity).toFixed(2) })
				// 		}
						
					
				// 	})
				// })

				// console.log(this.titles);
				// console.log(this.lines);
				this.isRequest = false
				
			}else{
				this.isRequest = false
				console.log('err:' + res.data.errMsg);
			}
		},
		async getMulberryLoop(type){
			let _this = this
			this.isRequest = true
			this.titles = []
			this.lines = []
			let res = await getMulberryDistribute({
				date:this.currentDate,
				projectId:this.$store.getters.projectId,
				range:this.radio.toUpperCase()
			})
			
			if(res.data.code == 200){
				
				let result = res.data.data
				console.log(result);
				
				

				_this.titles.push({"name":result.project.projectName})
				result.areas.forEach(item =>{
					
					// if(item.data.electricity !== 0){
						_this.titles.push({"name":item.area.areaName})
						_this.lines.push({"source": result.project.projectName, "target":item.area.areaName, "value":Number(item.data.electricity).toFixed(2) })
					// }
					
					item.loops.forEach((loop,ldx)=>{
						if(loop.data.electricity !== 0){
							_this.titles.push({"name":loop.deviceLoop.loopName})
						_this.lines.push({"source": item.area.areaName, "target":loop.deviceLoop.loopName, "value":Number(loop.data.electricity).toFixed(2) })
						}
						
					
					})
				})

				// console.log(this.titles);
				// console.log(this.lines);
				this.isRequest = false
				
			}else{
				this.isRequest = false
				console.log('err:' + res.data.errMsg);
			}
		},
		tabEnergyidx(idx, nothing){
			if(nothing && nothing == '0.00') return
			this.energyIdx = idx
			let arr = ['power', 'water', 'cooling', 'heat', 'total']
			
			this.getEnergyLink(idx)
			// console.log(this.$store.getters.selProjectInfo.projectType);
			if(this.$store.getters.selProjectInfo.projectType == 1){
				// if(this.$store.getters.projectId == 18){
					this.getMulberryItem(arr[idx])
				// }else{
				// 	this.getMulberryLoop(arr[idx])
				// }
				
			}else{
				this.getMulberry(arr[idx])
			}
		},
		getEnergyLink(idx){
			this.typeEnergy(this.radio.toUpperCase())
			this.color = this.colors[this.energyIdx]
			let arr = ['electricity', 'water', 'heat', 'cooling', '']
			
			// if(idx == 4){
			// 	this.getProjecStandardCoal()
			// }else{
				// this.getDiagramProjectTypeEnergy(arr[idx])
				this.getItemEnergyConsumption()
			// }
		},
		async getItemEnergyConsumption(){
			let arr = ['SPECIAL', 'AIR_CONDITIONER', 'LIGHTING', 'POWER']
			
			let promise = arr.map(item =>{
				return item = getitemEnergyConsumption({
					date:this.currentDate,
					projectId:this.$store.getters.projectId,
					range:this.radio.toUpperCase(),
					itemType:item
				})
			})
			
			let res = await Promise.all(promise)
			try{
				
				let itemArr = {}
				res.forEach((item, index) =>{
					let formatArr = item.data.data.result.map(item2 =>{
						return item2 = item2 == null ?null : Number(item2).toFixed(2)
					})
					if(this.currentDate !== dayStart(new Date())){
						formatArr.push(formatArr[0])
					}
					if(formatArr.length >0){
						itemArr[arr[index]] = formatArr
					}
					
					// itemArr[arr[index]] = item.data.data.result.map(item2 =>{
					// 	return item2 = item2 == null ?null : Number(item2).toFixed(2)
					// })
				})
				
				this.itemArr = itemArr
			}catch(err){
				console.log(err);
			}

		}
	},
	};
</script>

<style scoped lang="less">
.warp{
	height: 100%;
	width: 100%;
	background:none;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: #ffffff;

}
.EnergyConsumption{
	height:65.5vh ;
	display: flex;
	flex-direction: column;
	.title {
		height: 7vh;
		padding: 0 16rem;
		width: 100%;
		justify-content: flex-start;
		.demonstration {
			margin-right: 10rem;
			}

		.block {
			margin-right: 80rem;
			}

		.dateSelect {
			margin-right: 10rem;
			}

		.per {
			margin-left: 10rem;
			}

		.el-radio {
			margin-right: 20rem;
		}

	}
	.typeDetails{
		padding: 0 16rem;
		height: 7vh;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		.type{
			width: 225rem;
			height: 56rem;
			background: #F5F5F5;
			border-radius: 4px;
			display: flex;
			justify-content: space-evenly;
			align-items: center;
			border: 1px solid transparent;
			cursor: pointer;
			&>img{
				width: 30rem;
				height: 30rem;
			}
			.con{
				width: calc(100% - 55rem );
				height: 100%;
				position: relative;
				display: flex;
				flex-direction: column;
				// justify-content: space-evenly;
				padding: 7rem 0;
				&>div:nth-child(1){
					font-size: 12rem;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #333333;
				}
				&>div:nth-child(2){
					font-size: 22rem;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #0D94FF;
					&>span{
						font-size: 14rem;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #0D94FF;
					}
				}
				.up{
					position: absolute;
					right: 15rem;
					top: 7rem;
					font-size: 12rem;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #68D86A;
					&::before{
						content: '';
						width: 8rem;
						height: 10rem;
						// border-top: 5rem solid #68D86A;
						// border-bottom: 5rem solid transparent;
						// border-left: 5rem solid transparent;
						// border-right: 5rem solid transparent;
						background: url('../../assets/img/xia1.png') no-repeat;
						background-size: 100% 100%;
						position: absolute;
						left: 118%;
						top: 25%;
					}
				}
				.down{
					color: #FD4238;
					&::before{
						content: '';
						width: 8rem;
						height: 10rem;
						background: url('../../assets/img/shang.png') no-repeat;
						background-size: 100% 100%;
						// border-top: 5rem solid transparent;
						// border-bottom: 5rem solid #FD4238;
						// border-left: 5rem solid transparent;
						// border-right: 5rem solid transparent;
						position: absolute;
						left: 118%;
						top: 25%;
					}
				}
			}
		}

		.se{
			border: 1px solid #0D94FF;
			background: rgba(13,148,255,0.08);
		}
		.nothing{
			cursor:not-allowed
		}
	}
	.mulberry{
		padding: 1vh 16rem ;
		box-sizing: border-box;
		height: calc(100% - 15vh);
		border-top: 1px solid rgba(0, 0, 0, 0.15);
    	border-bottom: 1px solid rgba(0, 0, 0, 0.15);
		.mulName{
			height: 30rem;
			font-size: 14rem;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #0D94FF;
		}
		#nulBerryDiagram{
			height: calc(100% - 45rem);
			position: relative;
			overflow: auto;
			&>img{
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
			&>span{
				position: absolute;
				top: 85%;
				left: 50%;
				transform: translate(-50%, -50%);
				font-size: 18rem;
				color: #666;
			}
		}
	}
	
}
.energyxou{
	width: 62.1875vw;
	height: 25vh;
	// background-color: #fff;
	padding: 0 16rem;
	position:relative;
	.title{
		height: 36rem;
		line-height: 36rem;
		font-size: 16rem;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #333333;
	}
	.tabType{
		height: 36rem;
		width: 100%;
		line-height: 36rem;
		font-size: 14rem;
		font-family: Source Han Sans CN;
		font-weight: 400;
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
		position: absolute;
		right: 22rem;
		z-index: 11;
		.typeItem{
			margin-left: 16rem;
			color: #333333;
			cursor: pointer;
		}
		.se{
			color: #0D94FF;
		}
	}
	
	.warp{
		height: 21vh;
		.nothing{
			position: absolute;
			top: 45%;
			left: 0%;
			right: 0%;
			margin: auto;
			width: 23%;
			height: 50%;
			background: url('../../assets/img/not_found_data.png') no-repeat;
			background-size: 100% 100%;
		}
	}
}
</style>